import { generateId } from '@freelancer/datastore/testing/helpers';
import type { FlareActionMap } from './flare-action-map.model';

export interface GenerateFlareActionMap {
  readonly id?: string;
  readonly flareCheckpointId: number;
  readonly actions: { readonly [key: string]: boolean };
  readonly sourceId?: number; // TODO: T316888: Allow flare to use sourceTypes in the future
}

/**
 * Create a Freelancer Automation Rule Engine (FLARE) action map object
 */
export function generateFlareActionMapObject({
  id = generateId().toString(),
  flareCheckpointId,
  actions,
  sourceId,
}: GenerateFlareActionMap): FlareActionMap {
  return {
    id,
    flareCheckpointId,
    actions,
    sourceId,
  };
}
